import React, { Suspense, lazy, useState } from 'react';

// R6 — a sheet/dialog whose code loads the first time it opens (then stays mounted so it
// can animate closed). The chunk is also fetched when the browser is idle after load.
export function lazyWhenOpen(load) {
  const Sheet = lazy(load);
  if (typeof window !== 'undefined') {
    const idle = window.requestIdleCallback || ((f) => setTimeout(f, 2500));
    const pre = () => idle(() => load().catch(() => {}), { timeout: 6000 });
    if (document.readyState === 'complete') pre();
    else window.addEventListener('load', pre, { once: true });
  }
  return function LazyWhenOpen(props) {
    const [used, setUsed] = useState(false);
    if (props.open && !used) setUsed(true);
    if (!used && !props.open) return null;
    return (
      <Suspense fallback={null}>
        <Sheet {...props} />
      </Suspense>
    );
  };
}

export default lazyWhenOpen;
